export const FETCH_TERMINAL_PRICE_ASYNC = 'FETCH_TERMINAL_PRICE_ASYNC';
export const FETCH_TERMINAL_PRICE_END_COMPLETE =
  'FETCH_TERMINAL_PRICE_END_COMPLETE';
export const FETCH_TERMINAL_PRICE_ASYNC_END = 'FETCH_TERMINAL_PRICE_ASYNC_END';
export const CREATE_TERMINAL_REQUEST_ASYNC = 'CREATE_TERMINAL_REQUEST_ASYNC';
export const CREATE_TERMINAL_REQUEST_END_COMPLETE =
  'CREATE_TERMINAL_REQUEST_END_COMPLETE';
export const CREATE_TERMINAL_REQUEST_ASYNC_END =
  'CREATE_TERMINAL_REQUEST_ASYNC_END';
export const FETCH_ALL_TERMINAL_START_ASYNC = 'FETCH_ALL_TERMINAL_START_ASYNC';
export const FETCH_ALL_TERMINAL_END_ASYNC = 'FETCH_ALL_TERMINAL_END_ASYNC';
export const FETCH_ALL_TERMINALS = 'FETCH_ALL_TERMINALS';
export const FETCH_TERMINAL_REQUESTS = 'FETCH_TERMINAL_REQUESTS';
export const ACTIVATE_TERMINAL_ASYNC_START = 'ACTIVATE_TERMINAL_ASYNC_START';
export const ACTIVATE_TERMINAL_ASYNC_END = 'ACTIVATE_TERMINAL_ASYNC_END';
export const ACTIVATE_TERMINAL_REQUEST = 'ACTIVATE_TERMINAL_REQUEST';
